import { render, staticRenderFns } from "./deleteNews.vue?vue&type=template&id=0fba1048&scoped=true"
import script from "./deleteNews.vue?vue&type=script&lang=ts"
export * from "./deleteNews.vue?vue&type=script&lang=ts"
import style0 from "./deleteNews.vue?vue&type=style&index=0&id=0fba1048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba1048",
  null
  
)

export default component.exports